import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Stack,
  CircularProgress,
  Chip,
  Divider,
  Typography,
} from "investira.react.components";
import { displays } from "investira.react.lib";
import services from "../../../../services";
import { PessoaImage, MutedCopy } from "../../../../components/molecules";
import { useEmpresasContext } from "../../../../contexts/EmpresasContext";

const EmpresaPatrocinadores = memo((props) => {
  const { state } = useEmpresasContext();
  const [patrocinadores, setPatrocinadores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    services.pessoas.patrocinadores(
      { gestor_pessoa_id: props.pessoaId },
      (rRes) => {
        console.log(rRes);
        setPatrocinadores(rRes.data);
      },
      (rErr) => {
        console.log(rErr);
      },
      () => {
        setIsLoading(false);
      }
    );
  }, [props.pessoaId]);

  if (isLoading) {
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        sx={{ py: 2 }}
      >
        <CircularProgress size={24} />
      </Stack>
    );
  }

  return (
    <Stack direction="column" spacing={2} component="section">
      {patrocinadores.map((xPessoa, xIndex) => {
        const {
          pessoa_id,
          logo_pessoa_id,
          pessoa_fantasia,
          pessoa,
          logo_ok,
          cnpj,
        } = xPessoa;
        return (
          <Link to={`/empresas/${pessoa_id}`}>
            <Stack
              component="article"
              spacing={3}
              justifyContent="space-between"
              sx={{ py: 1 }}
            >
              <Stack
                direction="row"
                spacing={3}
                alignItems={{ xs: "flex-start" }}
              >
                <Stack>
                  <PessoaImage
                    id={logo_pessoa_id}
                    logoPessoaId={logo_pessoa_id}
                    alt={pessoa_fantasia || pessoa}
                    title={pessoa_fantasia}
                    hasLogo={logo_ok}
                    mercado={"INS"}
                    size={50}
                  />
                </Stack>
                <Stack spacing={2}>
                  <Stack>
                    <Typography
                      variant="body1"
                      component="h1"
                      color="textPrimary"
                      aria-label={`Nome da empresa: ${
                        pessoa_fantasia || pessoa
                      }`}
                    >
                      {pessoa_fantasia || pessoa}
                    </Typography>
                    <Typography
                      variant="caption"
                      component="h2"
                      color="textSecondary"
                    >
                      {pessoa}
                    </Typography>
                  </Stack>
                  <Stack flexGrow={1} direction="row" gap={1} flexWrap="wrap">
                    {cnpj && (
                      <MutedCopy value={cnpj}>
                        <Chip
                          label={displays.cnpj(cnpj)}
                          size="small"
                          color="primary"
                          variant="outlined"
                          sx={{ px: 1.5 }}
                        />
                      </MutedCopy>
                    )}
                  </Stack>
                </Stack>
              </Stack>
              <Divider flexItem />
            </Stack>
          </Link>
        );
      })}
    </Stack>
  );
});

export default EmpresaPatrocinadores;
